import React from 'react';
import { connect } from 'react-redux';
import { Collapse, Typography, Button, Table, Tabs } from 'antd';
import { CaretRightOutlined } from '@ant-design/icons';
import style from './index.scss';

const { TabPane } = Tabs;
const { Text } = Typography;
const { Panel } = Collapse;

/**
 * RiskIndicators Class
 */
class RiskIndicators extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const layeringTableColumns = [
      {
        title: 'Risk Indicator',
        dataIndex: 'name',
        width: '70%'
      },
      {
        title: 'Threshold',
        dataIndex: 'threshold',
        width: '30%'
      }
    ];

    const layeringTableData = [
      {
        key: '1',
        name: 'Number of Entities in Tax-haven countries',
        threshold: {}
      },
      {
        key: '2',
        name: 'Number of Past Alerts of Last 90 Days',
        threshold: {}
      },
      {
        key: '3',
        name: 'Total Deposit Amount over Last 30 Days',
        threshold: {}
      },
      {
        key: '4',
        name: 'Ratio of Last 30 days vs Last 180 days Deposit Amount',
        threshold: {}
      }
    ];

    const highVelocityTableColumns = [
      {
        title: 'Static Risk Indicator',
        dataIndex: 'name',
        width: '70%'
      },
      {
        title: 'Threshold',
        dataIndex: 'threshold',
        width: '30%'
      }
    ];

    const highVelocityTableData = [
      {
        key: '1',
        name: 'Amount of incoming fund transfer in last 30 days',
        threshold: {}
      },
      {
        key: '2',
        name: 'Volume of incoming fund transfer in last 30 days',
        threshold: {}
      },
      {
        key: '3',
        name: 'Amount of outgoing fund transfer in last 30 days',
        threshold: {}
      },
      {
        key: '4',
        name: 'Volume of outgoing fund transfer in last 30 days',
        threshold: {}
      }
    ];

    return (
      <Tabs defaultActiveKey="1" type="line">
        <TabPane tab="Derived" key="1">
          <Collapse
            defaultActiveKey={['1', '2']}
            ghost
            expandIcon={({ isActive }) => (
              <CaretRightOutlined rotate={isActive ? 90 : 0} />
            )}>
            <Panel
              key="1"
              header="Typology: Layering of funds to finance terrorism"
              className={style.panel}>
              <div>
                <Text type="secondary" className={style.fontWeightBold}>
                  Technique: Layering of funds
                </Text>
                <Button size="small" className={style.floatRight}>
                  Reset
                </Button>
              </div>

              <Table
                bordered
                size="small"
                columns={layeringTableColumns}
                dataSource={layeringTableData}
                pagination={false}
                className={style.indicatorTable}
              />
            </Panel>
            <Panel
              key="2"
              header="Typology: High velocity of funds through an account"
              className={style.panel}>
              <div>
                <Text type="secondary" className={style.fontWeightBold}>
                  Technique: High Frequent Transactions from unrelated entities
                </Text>
                <Button size="small" className={style.floatRight}>
                  Reset
                </Button>
              </div>

              <Table
                bordered
                size="small"
                columns={highVelocityTableColumns}
                dataSource={highVelocityTableData}
                pagination={false}
                className={style.indicatorTable}
              />
            </Panel>
          </Collapse>
        </TabPane>
        <TabPane tab="Regulatory" key="2">
          <div className={style.alignRight}>
            <Button size="small">Reset</Button>
          </div>

          <Table
            bordered
            size="small"
            columns={layeringTableColumns}
            dataSource={layeringTableData}
            pagination={false}
            className={style.indicatorTable}
          />
        </TabPane>
      </Tabs>
    );
  }
}

/**
 * mapStateToProps
 * @param state
 * @param ownProps
 * @returns {{typologyListingDashboard: trmDashboard}}
 */
function mapStateToProps(state, ownProps = {}) {
  return {
    trmDashboard: state.trmDashboard
  };
}

/**
 * mapDispatchToProps
 * @param dispatch
 * @param ownProps
 * @returns {{dispatch: *}}
 */
function mapDispatchToProps(dispatch, ownProps = {}) {
  return {
    fetchRunInstanceHistory: (payload) => {
      dispatch(fetchRunInstanceHistory(payload));
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(RiskIndicators);
